import { CalendarDaysIcon, ChatBubbleLeftRightIcon, FlagIcon, SignalIcon, StarIcon } from "@heroicons/react/24/outline";
import type { CommandMenuLink } from "@packages/core-client/registration/command-menu/CommandMenuLinksRegistry.ts";
import type { LinkIcon } from "@packages/core-client/registration/link.ts";
import { buildPersonPath } from "@packages/core-client/routing/personPath.ts";
import type { i18n } from "i18next";

interface MeShortcutsAvailability {
    hasGoals: boolean;
    hasReviews: boolean;
    hasEngagement: boolean;
    hasMeetings: boolean;
}

interface MeShortcut {
    id: string;
    segment: string;
    icon: LinkIcon;
    isAvailable: (availability: MeShortcutsAvailability) => boolean;
}

const ME_GROUP_ID = "me";
const TOP_PRIORITY = 249;

const ME_SHORTCUTS: MeShortcut[] = [
    { id: "goals", segment: "progression/goals", icon: FlagIcon, isAvailable: ({ hasGoals }) => hasGoals },
    { id: "reviews", segment: "progression/reviews", icon: StarIcon, isAvailable: ({ hasReviews }) => hasReviews },
    { id: "engagement", segment: "engagement", icon: SignalIcon, isAvailable: ({ hasEngagement }) => hasEngagement },
    { id: "feedback", segment: "engagement/feedback", icon: ChatBubbleLeftRightIcon, isAvailable: ({ hasEngagement }) => hasEngagement },
    { id: "meetings", segment: "meetings", icon: CalendarDaysIcon, isAvailable: ({ hasMeetings }) => hasMeetings }
];

export function meShortcutLinks(memberId: string, availability: MeShortcutsAvailability, i18nextInstance: i18n): CommandMenuLink[] {
    return ME_SHORTCUTS.flatMap((shortcut, index) =>
        shortcut.isAvailable(availability)
            ? [
                  {
                      id: `me-${shortcut.id}-palette`,
                      to: buildPersonPath(memberId, shortcut.segment),
                      groupId: ME_GROUP_ID,
                      icon: shortcut.icon,
                      priority: TOP_PRIORITY - index,
                      i18next: {
                          instance: i18nextInstance,
                          namespace: "Navigation",
                          labelKey: `me.${shortcut.id}.label`,
                          descriptionKey: `me.${shortcut.id}.description`,
                          parentLabelKey: "me.label",
                          keywordsKey: `me.${shortcut.id}.keywords`,
                          groupLabelKey: "me.label"
                      }
                  }
              ]
            : []
    );
}
